module.exports = __webpack_public_path__ + "static/media/Edit.aec70d7c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Icons/Edit.svg
// module id = 1124
// module chunks = 0